import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter, Route } from 'react-router-dom';

import { Provider } from 'react-redux';
import ReactGA from 'react-ga';
import ConnectedIntlProvider from 'Containers/ConnectedIntlProvider';

import { IS_PROD } from 'Settings';
import configureStore from './store/configureStore';
import styles from './styles/index.scss';

import ModelEmbedder from 'Containers/ModelEmbedder';

// Initialize Google Analytics tracking
ReactGA.initialize('UA-34697160-8', {
  debug: !IS_PROD,
  gaOptions: {
    anonymizeIp: true,
  },
});

const store = configureStore();

const gameSlug = 'mammals';

render(
  <Provider store={store}>
    <ConnectedIntlProvider>
      <BrowserRouter>
        <Route
          path="*"
          component={() => <ModelEmbedder gameSlug={gameSlug} />}
        />
      </BrowserRouter>
    </ConnectedIntlProvider>
  </Provider>,
  document.getElementById('app')
);
